import Button from '@/components/buttons/Button'
import _get from 'lodash/get'
import { hoaContactsStore } from '@/services/HoaContacts/store'

export const methods = {
  determineRows: function(list) {
    let filteredList = list

    var rows = filteredList.map(entry => {
      const description = _get(entry, 'description', '')
      const title = _get(entry, 'title', '')
      const email = _get(entry, 'email', '')
      const phone = _get(entry, 'phone', '')

      return {
        title,
        description,
        email,
        phone,
        details: {
          component: Button,
          props: {
            onClick: () => {
              this.editHoaContact(entry)
            },
            text: 'Edit'
          }
        },
        erase: {
          component: Button,
          props: {
            onClick: () => {
              this.confirmDeleteHoaContact(entry)
            },
            text: 'Delete'
          }
        }
      }
    })

    this.rows = rows
  },

  async confirmDeleteHoaContact(entry) {
    this.$buefy.dialog.confirm({
      title: 'Deleting Hoa Contact',
      message: `Are you sure you want to <b>delete</b> this Hoa Contact, "${entry.title}"?`,
      confirmText: 'Delete Hoa Contact',
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => await this.deleteHoaContact(entry.hoaContactID)
    })
  },

  async deleteHoaContact(hoaContactID) {
    try {
      await hoaContactsStore.dispatch('deleteHoaContacts', {
        hoaContactID,
        done: () => {
          this.loading = false
          this.reload()
        }
      })
    } catch (e) {
      console.debug('There was an issue deleting this hoa contact.' + e)
    }
  },

  async reload() {
    console.debug('in reload...')
    this.loading = true

    await hoaContactsStore
      .dispatch('getHoaContactsList', {
        hoaID: this.hoaId
      })
      .then(({ list }) => {
        this.determineRows(list)
        this.loading = false
      })
  },

  editHoaContact(hoaContact) {
    if (hoaContact) {
      this.toggle = true
      this.selectedHoaContact = hoaContact
    }
  },

  createHoaContactModal() {
    this.toggle = true
    this.selectedHoaContact = null
  }
}
